<template>
  <header v-if="showHeader" :class="showTopMargin ? 'top-margin' : ''">
    <!-- <img src="~@/assets/eyejack-logo-white.png" alt="eyejack" style="float:left; height: 50px;" /> -->
    <!-- <h1>{{currentStep}}</h1> -->
    <progress-indicator v-if="showProgress" :style="progressStyleObject"></progress-indicator>
    <button v-if="showCancelButton" class="primaryButton white-outline" @click="cancelCreation">Cancel</button>
  </header>
</template>

<script>
import progressIndicator from "@/components/ProgressIndicator";
import DeleteArtwork from "@/mutations/DeleteArtwork";

export default {
  name: "header-bar",
  props: {
    showHeader: {
      type: Boolean,
      required: false
    },
    showTitle: {
      type: Boolean,
      required: false
    }
  },
  data() {
    return {
      platform: process.platform
    };
  },
  components: {
    progressIndicator
  },
  computed: {
    currentStep() {
      return this.$store.getters.currentStep.name;
    },
    showProgress() {
      return (
        this.$store.getters.currentStep.index !== 0 &&
        this.$route.params.from !== "artwork-detail-page" &&
        this.$route.params.from !== "collection-detail-page"
      );
    },
    showCancelButton() {
      // return this.$store.getters.currentStep.name !== "preview";
      return this.$route.params.from !== "artwork-detail-page" && this.$route.params.from !== "collection-detail-page";
    },
    showTopMargin() {
      // Browser app: there's no native/Electron title bar, so never offset the header —
      // it should sit flush with the top of the viewport.
      return false;
    },
    progressStyleObject() {
      // Cancel now sits on the right, so pad the indicator on the left by the same amount to keep
      // the steps optically centred in the header.
      return {
        paddingLeft: this.showCancelButton ? "123px" : "0"
      }
    }
  },
  methods: {
    cancelCreation() {
      if (this.$router.currentRoute.params.from && this.$router.currentRoute.name === "artwork-preview-page") {
        this.$apollo
          .mutate({
            mutation: DeleteArtwork,
            variables: {
              input: {
                id: this.$router.currentRoute.params.id
              }
            }
          })
          .then(() => {
            this.$store.commit("DELETE_ARTWORK", {
              artworkID: this.$router.currentRoute.params.id
            });
            this.$router.push({ name: "artworks-page" });
            this.clearState();
          })
          .catch(error => {
            console.error(error);
          });
      }
      // else if (this.$router.currentRoute.params.id) {
      //   this.$router.push({
      //     name: "artwork-detail-page",
      //     params: { id: this.$router.currentRoute.params.id }
      //   });
      // }
      else {
        this.$router.push({ name: "artworks-page" });
        this.clearState();
      }
    },
    clearState() {
      this.$store.dispatch("clearState");
      this.$store.commit("setUserStepIndex", {
        index: 0
      });
      this.$store.commit("setCurrentStep", {
        name: "",
        index: 0
      });
    }
  }
};
</script>

<style lang="stylus" scoped>

@import "../styles/main.styl"

header
  display: block
  display: flex
  align-items: center
  background-color: primary-color-red
  box-shadow: 0 0 shadow-y-height 0 color-shadow
  padding: 0px 40px 0px 40px
  height: 100px
  z-index: $navbar-z-index

  img
    padding-right: 20px

.top-margin {
  margin-top: titlebar-height
}

// Mobile: tighten the 40px side padding, extend under the iOS notch via safe-area, and drop the
// desktop title-bar gap (there's no native titlebar in the browser).
@media (max-width: mobile-breakpoint)
  // Single inline row, flush to the top: Cancel + steps side by side, vertically centred (the base
  // header is already display:flex; align-items:center). Keep the bar its normal height.
  header
    padding: env(safe-area-inset-top) 14px 0 14px
    height: auto
    min-height: 64px

  // Sit to the left of Cancel (which is now on the right) and centre within that space, capped so
  // the steps don't spread too far apart on wider phones.
  .progress-indicator
    flex: 1
    min-width: 0
    max-width: 340px
    margin: 0 auto
    padding-left: 0 !important
</style>
